var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.productsTable.data.length>0)?_c('div',{staticClass:"container"},[_c('vue-table-dynamic',{ref:"tableProducts",staticClass:"tableModifier",attrs:{"params":_vm.productsTable},on:{"row-click":_vm.onSelect}})],1):_c('Loading')}
var staticRenderFns = []

export { render, staticRenderFns }